import SliderVideo from './slider-video';
import Progressbar from 'progressbar.js';

export default class SliderVideoDesktop extends SliderVideo {
    constructor(...args) {
        super(...args);

        this.animateLine = [];

    }


    init(){
        super.init();

        this.dom.title = this.dom.component.querySelectorAll('.title-video');
        this.dom.line = document.querySelectorAll('.cls-2');

    }

    bind() {
        super.bind();

        //Init all progress anim
        for (let i = 0; i < this.dom.line.length; i++) {
            this.initLine(this.dom.line[i]);
        }

        //First anim
        this.animateLine[this.indexVideoPrev].animate(1);


        //Interval
        this.interval = setInterval(()=>{
            if (this.isPaused == false){
                this._intervalVideo()
            }
        }, this.intervalDuration);

        //Event click title
        for (let i = 0; i < this.dom.title.length; i++) {
            this.dom.title[i].addEventListener('click', this._changeVideo.bind(this, i));
        }


    }

    _intervalVideo(){
        let index;

        if (this.indexVideoPrev == this.lengthSlide){
            index = 0
        }
        else {
            index = this.indexVideoPrev + 1;
        }

        //Activ next title
        this.dom.title[index].classList.add('active');

        //Anim line
        this.animateLine[this.indexVideoPrev].set(0);
        this.animateLine[index].animate(1);

        // Remove previous video
        TweenMax.to(this.dom.containerVideo[this.indexVideoPrev], 0.5, {
            autoAlpha: 0
        });
        this.dom.title[this.indexVideoPrev].classList.remove('active');

        // Display next containerVideo
        TweenMax.to(this.dom.containerVideo[index], 0.5, {
            autoAlpha: 1
        });

        this.indexVideoPrev = index;
    }

    _changeVideo(index){

        this.isPaused = false;

        //Paused all video
        for (let i = 0; i < this.dom.video.length; i++) {
            this.dom.video[i].pause();
        }

        //Reset setInterval
        clearInterval(this.interval);
        this.interval = setInterval(()=>{
            if (this.isPaused == false){
                this._intervalVideo()
            }
        }, this.intervalDuration);

        // Remove previous containerVideo
        TweenMax.to(this.dom.containerVideo[this.indexVideoPrev], 0.5, {
            autoAlpha: 0
        });
        this.dom.title[this.indexVideoPrev].classList.remove('active');

        //Activ next title
        this.dom.title[index].classList.add('active');

        //Anim line
        this.animateLine[this.indexVideoPrev].set(0);
        this.animateLine[index].animate(1);

        // Display next containerVideo
        TweenMax.to(this.dom.containerVideo[index], 0.5, {
            autoAlpha: 1
        });

        this.indexVideoPrev = index;
    }

    initLine(target){

        this.animation = new Progressbar.Path(target, {
            easing: 'linear',
            duration: this.intervalDuration - 100
        });
        this.animation.set(0);
        this.animateLine.push(this.animation);

    }
    /*

    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/slider-video/slider-video.desktop.js